import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { Accordion, AccordionDetails, AccordionSummary, Box } from "@mui/material";
import { useTranslation } from 'react-i18next';
import MessageBanner from '../../../../components/common/MessageBanner/MessageBanner';
import { QuestionRenderer } from "../CommonComponents";
export const SectionRenderer = ({ section, answers, onChange, translator, disabled, evaluator, context, isReadMode = false }) => {
    const { t } = useTranslation();
    // 1) Filtrar sólo preguntas de esta sección
    const questionsToRender = section.questions
        .filter(q => {
        if (!q.displayConditions)
            return true;
        return evaluator.evaluateDisplayConditions(q.displayConditions, answers, context);
    })
        .map(q => {
        // 2) Aplica filtro de opciones en multipleChoice
        let qForRender = q;
        if (q.type === 'multipleChoice') {
            const filteredOpts = q.answers.filter(a => {
                if (!a.displayConditions)
                    return true;
                return evaluator.evaluateDisplayConditions(a.displayConditions, answers, context);
            });
            qForRender = Object.assign(Object.assign({}, q), { answers: filteredOpts });
        }
        // 3) Computa disabled
        const isDisabled = q.disableWhen
            ? !evaluator.evaluateDisableConditions(q.disableWhen, answers, context)
            : false;
        return (_jsx(QuestionRenderer, { isReadMode: isReadMode, question: qForRender, value: answers[q.variableName], details: answers[q.variableName + "_details"], onChange: onChange, translator: translator, disabled: isDisabled || disabled }, q.id));
    });
    // 4) Usa el flag de la sección para decidir Accordion vs fragment
    if (section.useAccordion && !isReadMode) {
        return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: 'col-12' }, { children: _jsxs(MessageBanner, Object.assign({ cssClass: "grid-mb-1 mt-0", type: "info" }, { children: [_jsx("p", { children: t("PDDForm.serviceProviderInfo1") }), _jsx("p", { children: t("PDDForm.serviceProviderInfo2") })] })) })), _jsx("div", Object.assign({ className: 'col-12' }, { children: _jsxs(Accordion, Object.assign({ className: "accordion-validate-questions" }, { children: [_jsx(AccordionSummary, Object.assign({ expandIcon: _jsx(ExpandMoreIcon, {}) }, { children: _jsxs(Box, Object.assign({ display: "flex", alignItems: "center", width: "100%" }, { children: [_jsx(ManageSearchIcon, { fontSize: "medium", className: 'me-1' }), _jsx("h3", { children: t('PDDForm.title-accordion-validations') })] })) })), _jsx(AccordionDetails, Object.assign({ sx: { p: 0, pt: 1 } }, { children: questionsToRender }))] })) }))] }));
    }
    return _jsx(_Fragment, { children: questionsToRender });
};
